import { Input } from '@deity-io/portal-ui';
import type { FC } from 'react';

interface IMethodProps {
  isEditable: boolean;
  path: string;
  onChange: (path: string[], val: string) => void;
}
export const Path: FC<IMethodProps> = ({ isEditable, path, onChange }) => (
  <Input
    label="Path"
    type="text"
    name="path"
    id="path"
    value={path}
    onChange={e => onChange(['path'], e.target.value)}
    placeholder="/remaining-path"
    disabled={!isEditable}
    sx={{ marginY: 2 }}
    autoComplete="off"
  />
);
